/* global axios */
import ApiClient from './ApiClient';

class ConversationAppointmentsAPI extends ApiClient {
  constructor() {
    super('conversations', {
      accountScoped: true,
    });
  }

  getUrl(conversationId) {
    return `${this.baseUrl()}/conversations/${conversationId}/appointments`;
  }

  get(conversationId) {
    return axios.get(this.getUrl(conversationId));
  }

  show(conversationId, appointmentId) {
    return axios.get(`${this.getUrl(conversationId)}/${appointmentId}`);
  }

  create(conversationId, appointmentData) {
    return axios.post(this.getUrl(conversationId), {
      appointment: appointmentData,
    });
  }

  update(conversationId, appointmentId, appointmentData) {
    return axios.patch(`${this.getUrl(conversationId)}/${appointmentId}`, {
      appointment: appointmentData,
    });
  }

  delete(conversationId, appointmentId) {
    return axios.delete(`${this.getUrl(conversationId)}/${appointmentId}`);
  }

  // Buscar todos os appointments do account
  getAll(params = {}) {
    return axios.get(`${this.baseUrl()}/appointments`, { params });
  }

  // Buscar appointments por intervalo de datas
  getByDateRange(startDate, endDate, params = {}) {
    return axios.get(`${this.baseUrl()}/appointments`, {
      params: {
        ...params,
        start_date: startDate,
        end_date: endDate,
      },
    });
  }
}

export default new ConversationAppointmentsAPI();
